
import { computed, defineComponent } from 'vue'

import { maska } from 'maska'

const TIME_TOKENS = {
    h: { pattern: /[0-2]/ },
    H: { pattern: /[0-9]/ },
    '*': { pattern: /[0-3]/ },
    m: { pattern: /[0-5]/ },
    M: { pattern: /[0-9]/ },
}

export default defineComponent({
    directives: {
        maska,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const TIME_MASK_FULL = 'hH:mM'
        const TIME_MASK_SHORT = 'h*:mM'

        const TIME_MASK = computed(() => {
            if (!props.value) return TIME_MASK_FULL
            if (props.value[0] === '2') return TIME_MASK_SHORT
            return TIME_MASK_FULL
        })

        const emitInput = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('update:value', target.value)
        }

        const emitChange = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('change', target.value)
        }

        return { emitInput, emitChange, TIME_MASK, TIME_TOKENS }
    },
})
